import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Login and Register removed
import ServiceInfo from '../screens/ServiceInfo';
import PrivacyPolicy from '../screens/PrivacyPolicy';
import UseOfTerms from '../screens/UseOfTerms';
import CookiePolicy from '../screens/CookiePolicy';
// FAQUI removed
// WelcomeUI removed
import PaymentSecurity from '../components/PaymentSecurity';
// BuyBookProblem removed
import DeleteAccount from '../screens/DeleteAccount';
import OpenInApp from '../screens/OpenInApp';
// EnterPaymentCodeScreen removed

const RoutesComponent = ({ user }) => {
  // Offline functionality removed - preview site only

  return (
    <>
      <Routes>
        <Route path="/" element={<ServiceInfo />} />
        {/* Login and Register routes removed */}
        {/* WelcomeUI route removed */}

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<UseOfTerms />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        {/* BuyBookProblem route removed */}
        {/* FAQ route removed */}
        <Route path="/payment-security" element={<PaymentSecurity />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        {/* EnterPaymentCodeScreen route removed */}

        <Route path="/listen/:id" element={<OpenInApp />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

export default RoutesComponent;